export default "__VITE_ASSET__C5ygw8oG__"